import script from "./test.vue?vue&type=script&lang=ts&setup=true"
export * from "./test.vue?vue&type=script&lang=ts&setup=true"

import "./test.vue?vue&type=style&index=0&id=720ddd42&lang=css"

const __exports__ = script;

export default __exports__